module.exports = __webpack_public_path__ + "img/1571507019.ec852fc9.jpg";